// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

export const zAccountLinks = z.object({
  dazn: z.string().optional(),
  disneyPlus: z.string().optional(),
  hboMax: z.string().optional(),
  netflix: z.string().optional(),
  wowEntertainment: z.string().optional(),
  wowPremium: z.string().optional(),
  wowSports: z.string().optional(),
});

export const zActiveDevice = z.object({
  authorizedBySessionId: z.string().optional(),
  deviceId: z.string(),
  deviceModel: z.string().optional(),
  deviceType: z.string(),
  lastLogin: z.iso.datetime({ offset: true }),
  location: z.string().optional(),
  manufacturer: z.string().optional(),
  name: z.string(),
  platform: z.string(),
  sessionType: z.string(),
});

export const zAddress = z.object({
  additionalInfo: z.string().optional(),
  city: z.string().optional(),
  country: z.string().optional(),
  firstName: z.string().optional(),
  houseNumber: z.string().optional(),
  lastName: z.string().optional(),
  street: z.string().optional(),
  zip: z.string().optional(),
});

export const zAmazonLoginBody = z.object({
  $schema: z.url().readonly().optional(),
  accessToken: z.string().max(4096),
});

export const zAmazonLoginResponseBody = z.object({
  $schema: z.url().readonly().optional(),
  success: z.boolean(),
});

export const zAppleLoginBody = z.object({
  $schema: z.url().readonly().optional(),
  authorizationCode: z.string().max(4096),
  identityToken: z.string().max(8192),
});

export const zAppleLoginResponseBody = z.object({
  $schema: z.url().readonly().optional(),
  success: z.boolean(),
});

export const zAppleRegisterInputBody = z.object({
  $schema: z.url().readonly().optional(),
  authorizationCode: z.string().max(4096),
  familyName: z.string().max(256).optional(),
  givenName: z.string().max(256).optional(),
  identityToken: z.string().max(8192),
});

export const zApproveDeviceAuthorizationBody = z.object({
  $schema: z.url().readonly().optional(),
  approval: z.enum(['ALLOW', 'DENY']),
});

export const zApproximateLocation = z.object({
  city: z.string().optional(),
  postalCode: z.string().optional(),
});

export const zAuthSuccessResponse = z.object({
  $schema: z.url().readonly().optional(),
  success: z.boolean(),
});

export const zBookableDisplayTexts = z.object({
  checkoutFinePrint: z.string().optional(),
  description: z.string(),
  displayName: z.string(),
  euDataActFinePrint: z.string().optional(),
  productDetails: z.string().optional(),
  productDetailsLink: z.string().optional(),
  productNotesNoTrial: z.string().optional(),
  productNotesWithTrial: z.string().optional(),
  teaser: z.string().optional(),
  teaserHeadline: z.string().optional(),
});

export const zBookableIncludedItem = z.object({
  externalId: z.string().optional(),
  id: z.string(),
  type: z.string(),
});

export const zCancellationRequest = z.object({
  $schema: z.url().readonly().optional(),
  customerId: z.string(),
  dateOfBirth: z.string(),
  emailAddress: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  reason: z.string(),
  terminationType: z.string(),
});

export const zCart = z.object({
  product: z.string(),
});

export const zCategorizedFeatures = z.object({
  accountLinks: zAccountLinks,
  addOns: z.array(z.string()).nullable(),
  channelGroups: z.array(z.string()).nullable(),
  netflixUpgrade: z.string().optional(),
  pvr: z.int(),
  teaserChannelGroups: z.array(z.string()).nullable(),
  vodGroups: z.array(z.string()).nullable(),
});

export const zCheckEmailAvailabilityBody = z.object({
  $schema: z.url().readonly().optional(),
  available: z.boolean(),
  reason: z.enum(['invalid_domain', 'taken']).optional(),
  takenBy: z.string(),
});

export const zCommunicationPreferenceDto = z.object({
  activeChannels: z.array(z.string()).nullable(),
});

export const zCommunicationPreferencesSettingsDto = z.object({
  infos: zCommunicationPreferenceDto,
  offers: zCommunicationPreferenceDto,
  partners: zCommunicationPreferenceDto,
  surveys: zCommunicationPreferenceDto,
});

export const zCommunicationPreferencesDto = z.object({
  $schema: z.url().readonly().optional(),
  settings: zCommunicationPreferencesSettingsDto,
});

export const zCompleteRegistrationInputBody = z.object({
  $schema: z.url().readonly().optional(),
  dateOfBirth: z.string(),
  firstName: z.string().min(1).max(100),
  lastName: z.string().min(1).max(100),
  salutation: z.enum(['mr', 'mrs', 'mx']).optional(),
});

export const zCreateSessionInputBody = z.object({
  $schema: z.url().readonly().optional(),
  entryContext: z.enum(['OPEN_NEW']),
});

export const zCreateVerificationInputBody = z.object({
  $schema: z.url().readonly().optional(),
  cardType: z.enum(['NewIdCard', 'NewIdCard2108', 'OldIdCard', 'Passport']),
  idParts: z.array(z.string()).min(1).max(5).nullable(),
  pin: z.string().regex(/^[0-9]{4}$/),
});

export const zDateOfBirthSegments = z.object({
  day: z.int().gte(1).lte(31),
  month: z.int().gte(1).lte(12),
  year: z.int().gte(1900).lte(9999),
});

export const zDeviceAuthorizationBody = z.object({
  $schema: z.url().readonly().optional(),
  deviceName: z.string().optional(),
  status: z.enum(['NOT_EXISTING', 'EXPIRED', 'PENDING', 'DENIED', 'VERIFIED', 'TENANT_MISMATCH']),
});

export const zEmailValidation = z.object({
  $schema: z.url().readonly().optional(),
  token: z.string(),
});

export const zEntry = z.object({
  count: z.int(),
  suffix: z.string(),
});

export const zErrorDetail = z.object({
  location: z.string().optional(),
  message: z.string().optional(),
  value: z.unknown().optional(),
});

export const zErrorModel = z.object({
  $schema: z.url().readonly().optional(),
  detail: z.string().optional(),
  errors: z.array(zErrorDetail).nullish(),
  instance: z.url().optional(),
  status: z.int().optional(),
  title: z.string().optional(),
  type: z.url().optional().default('about:blank'),
});

export const zGetActiveDevicesResponseBody = z.object({
  $schema: z.url().readonly().optional(),
  currentDeviceId: z.string(),
  data: z.array(zActiveDevice).nullable(),
});

export const zGoogleLoginBody = z.object({
  $schema: z.url().readonly().optional(),
  credential: z.string().max(4096),
});

export const zGoogleLoginResponseBody = z.object({
  $schema: z.url().readonly().optional(),
  success: z.boolean(),
});

export const zHomeZoneLocation = z.object({
  latitude: z.number().optional(),
  longitude: z.number().optional(),
  radiusMeters: z.number().optional(),
});

export const zHomeZoneStatusResponse = z.object({
  $schema: z.url().readonly().optional(),
  accessPointCount: z.int().optional(),
  accessPointLimit: z.int().optional(),
  approximateLocation: zApproximateLocation.optional(),
  createdAt: z.string().optional(),
  location: zHomeZoneLocation.optional(),
  nextChangeAllowedAt: z.string().optional(),
  updatedAt: z.string().optional(),
});

export const zIapProduct = z.object({
  groupId: z.string().optional(),
  id: z.string().optional(),
  provider: z.string(),
});

export const zIapSubscription = z.object({
  productId: z.string(),
  start: z.iso.datetime({ offset: true }),
  trial: z.boolean().optional(),
});

export const zImage = z.object({
  colorMode: z.string(),
  scale: z.int(),
  url: z.string(),
});

export const zHardwareProduct = z.object({
  displayName: z.string(),
  externalId: z.string(),
  id: z.string(),
  images: z.array(zImage).nullable(),
});

export const zLinkAppleInputBody = z.object({
  $schema: z.url().readonly().optional(),
  identityToken: z.string().max(8192),
});

export const zLocationEligibilityBody = z.object({
  $schema: z.url().readonly().optional(),
  eligible: z.boolean(),
});

export const zLogisticsProviderInformation = z.object({
  returnConditionDisplayName: z.string().optional(),
  returnConditionName: z.string().optional(),
  returnLabelUrl: z.string().optional(),
  returnReasonDisplayName: z.string().optional(),
  returnReasonKey: z.string().optional(),
  serialNumbers: z.array(z.string()).nullable(),
  trackingId: z.string().optional(),
  trackingUrl: z.string().optional(),
});

export const zLogoutBody = z.object({
  $schema: z.url().readonly().optional(),
  logoutUrl: z.string(),
});

export const zModificationSubscription = z.object({
  endDate: z.iso.datetime({ offset: true }).optional(),
  id: z.string(),
  startDate: z.iso.datetime({ offset: true }),
});

export const zMonthlyPrice = z.object({
  originalPrice: z.number().optional(),
  price: z.number(),
  start: z.iso.datetime({ offset: true }),
  type: z.string(),
});

export const zOneTimePrice = z.object({
  name: z.string(),
  price: z.number(),
  type: z.string(),
});

export const zOption = z.object({
  name: z.string().optional(),
  quantity: z.int().optional(),
});

export const zOptionSubscription = z.object({
  activeDiscountSubscriptionIds: z.array(z.string()).nullable(),
  end: z.iso.datetime({ offset: true }).optional(),
  features: z.array(z.string()).optional(),
  id: z.string(),
  legacyName: z.string().optional(),
  nextPossibleCancellation: z.iso.datetime({ offset: true }).optional(),
  optionId: z.string(),
  quantity: z.int(),
  start: z.iso.datetime({ offset: true }),
  trial: z.boolean().optional(),
});

export const zOrderItem = z.object({
  articleNumber: z.string(),
  logisticsItemId: z.string(),
  price: z.number(),
  quantity: z.int(),
});

export const zParentalControlsStatusBody = z.object({
  $schema: z.url().readonly().optional(),
  enabled: z.boolean(),
  verified: z.boolean(),
});

export const zPasswordResetRequestResponse = z.object({
  $schema: z.url().readonly().optional(),
});

export const zPasswordBreachCheckResponseBody = z.object({
  $schema: z.url().readonly().optional(),
  entries: z.array(zEntry),
});

export const zPasswordResetConfirmation = z.object({
  $schema: z.url().readonly().optional(),
  password: z.string(),
  token: z.string(),
});

export const zPasswordResetRequest = z.object({
  $schema: z.url().readonly().optional(),
  email: z.string(),
  tenant: z.string().optional(),
});

export const zPasswordResetTokenValidation = z.object({
  $schema: z.url().readonly().optional(),
  token: z.string(),
});

export const zPaymentMethod = z.object({
  $schema: z.url().readonly().optional(),
  cardType: z.string().optional(),
  email: z.string().optional(),
  expiryMonth: z.int().optional(),
  expiryYear: z.int().optional(),
  holder: z.string().optional(),
  iban: z.string().optional(),
  last4: z.string().optional(),
  mandateReference: z.string().optional(),
  name: z.string().optional(),
  type: z.enum(['creditcard', 'sepa', 'paypal', 'none']),
});

export const zPeriod = z.object({
  interval: z.int(),
  unit: z.string(),
});

export const zDiscountSubscription = z.object({
  discountSubscriptionId: z.string(),
  duration: zPeriod.optional(),
  end: z.iso.datetime({ offset: true }).optional(),
  name: z.string(),
  percentage: z.number().optional(),
  start: z.iso.datetime({ offset: true }),
  status: z.string(),
  targetOptionIds: z.array(z.string()).nullable(),
  targetProductIds: z.array(z.string()).nullable(),
  voucherCode: z.string().optional(),
});

export const zPermission = z.object({
  code: z.string(),
  status: z.string(),
  version: z.int(),
});

export const zGetPermissionsOutputBody = z.object({
  $schema: z.url().readonly().optional(),
  data: z.array(zPermission).nullable(),
});

export const zPostFeedbackInputBody = z.object({
  $schema: z.url().readonly().optional(),
  fields: z.record(z.string(), z.unknown()),
  formId: z.string().min(1),
});

export const zPrice = z.object({
  monthly: z.array(zMonthlyPrice).nullable(),
  oneTime: z.array(zOneTimePrice).nullable(),
});

export const zCatalogProduct = z.object({
  minimumTermMonths: z.int(),
  price: zPrice,
});

export const zPriceSummaryLineItem = z.object({
  displayName: z.string(),
  originalPrice: z.number().optional(),
  price: z.number(),
  source: z.string(),
});

export const zMonthlyPriceSummary = z.object({
  lineItems: z.array(zPriceSummaryLineItem).nullable(),
  originalPrice: z.number().optional(),
  price: z.number(),
  start: z.iso.datetime({ offset: true }),
});

export const zOneTimePriceSummary = z.object({
  lineItems: z.array(zPriceSummaryLineItem).nullable(),
  originalPrice: z.number().optional(),
  price: z.number(),
});

export const zPriceSummary = z.object({
  $schema: z.url().readonly().optional(),
  monthly: z.array(zMonthlyPriceSummary).nullable(),
  oneTime: zOneTimePriceSummary,
});

export const zProductGroupEntry = z.object({
  description: z.string(),
  product: z.string(),
  title: z.string(),
});

export const zProductGroupLogo = z.object({
  colorMode: z.string(),
  scale: z.int(),
  url: z.string(),
});

export const zProductGroup = z.object({
  description: z.string(),
  entries: z.array(zProductGroupEntry).nullable(),
  id: z.string(),
  logos: z.array(zProductGroupLogo).nullable(),
  shortDescription: z.string(),
  subTitle: z.string().optional(),
  title: z.string(),
});

export const zCatalog = z.object({
  productGroups: z.array(zProductGroup).nullable(),
  products: z.record(z.string(), zCatalogProduct),
});

export const zConfiguratorSession = z.object({
  $schema: z.url().readonly().optional(),
  cart: zCart,
  catalog: zCatalog,
  id: z.string(),
  transactionId: z.string(),
});

export const zProductSubscriptionPhase = z.object({
  activeDiscountSubscriptionIds: z.array(z.string()).nullable(),
  displayName: z.string().optional(),
  features: z.array(z.string()).optional(),
  legacyName: z.string().optional(),
  productId: z.string(),
  start: z.iso.datetime({ offset: true }),
  trial: z.boolean().optional(),
});

export const zReAuthenticateBody = z.object({
  $schema: z.url().readonly().optional(),
  expiresAt: z.string(),
  stepUpToken: z.string(),
});

export const zReAuthenticateInputBody = z.object({
  $schema: z.url().readonly().optional(),
  password: z.string().min(1),
});

export const zRecentlyWatchedRowDto = z.object({
  $schema: z.url().readonly().optional(),
  editable: z.boolean(),
  editableLockedReason: z.string().optional(),
  enabled: z.boolean(),
});

export const zRecipient = z.object({
  additionalAddressInformation: z.string().optional(),
  city: z.string(),
  emailAddress: z.string(),
  firstName: z.string(),
  houseNumber: z.string(),
  lastName: z.string(),
  street: z.string(),
  telephoneNumber: z.string().optional(),
  zipCode: z.string(),
});

export const zRecipientAddress = z.object({
  city: z.string().optional(),
  country: z.string(),
  formattedCityAddressLine: z.string().optional(),
  formattedStreetAddressLine: z.string().optional(),
  houseNumber: z.string().optional(),
  postalCode: z.string().optional(),
  state: z.string().optional(),
  street: z.string().optional(),
});

export const zInvoiceView = z.object({
  createdAt: z.iso.datetime({ offset: true }),
  downloadUrl: z.string(),
  id: z.string(),
  recipientAddress: zRecipientAddress.optional(),
  recipientName: z.string().optional(),
  recipientSubName: z.string().optional(),
  totalGross: z.number(),
});

export const zRecordingSummary = z.object({
  $schema: z.url().readonly().optional(),
  availableRecordingHours: z.int(),
  finishedRecordingsSeconds: z.int(),
  numberOfFinishedRecordings: z.int(),
  numberOfLostRecordings: z.int(),
});

export const zRedeemBody = z.object({
  $schema: z.url().readonly().optional(),
  city: z.string().min(1).max(255),
  consentAccepted: z.literal(true),
  country: z.enum(['DE']),
  email: z.email().min(1).max(255),
  firstName: z.string().min(1).max(255),
  houseNumber: z.string().min(1).max(16),
  lastName: z.string().min(1).max(255),
  salutation: z.enum(['mr', 'mrs', 'mx']),
  street: z.string().min(1).max(255),
  zip: z.string().regex(/^[0-9]{5}$/),
});

export const zRedeemOutputBody = z.object({
  $schema: z.url().readonly().optional(),
  basketUrl: z.string(),
});

export const zRefreshSessionBody = z.object({
  $schema: z.url().readonly().optional(),
  flags: z.array(z.string()).nullable(),
  userHandle: z.string(),
});

export const zRegisterInputBody = z.object({
  $schema: z.url().readonly().optional(),
  context: z.string().optional(),
  dateOfBirth: z.string(),
  emailAddress: z.email(),
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  password: z.string().min(8),
  salutation: z.string().optional(),
  source: z.string().optional(),
});

export const zRetrieveSelfServiceTokenResult = z.object({
  $schema: z.url().readonly().optional(),
  token: z.string(),
});

export const zScheduledSubscriptionCancellation = z.object({
  createdBy: z.string(),
  executed: z.boolean(),
  revocable: z.boolean(),
  revocableUntil: z.iso.datetime({ offset: true }).optional(),
  scheduledFor: z.iso.datetime({ offset: true }),
  scheduledOn: z.iso.datetime({ offset: true }).optional(),
});

export const zSepaAddress = z.object({
  city: z.string().min(1).max(44),
  countryCode: z.string().length(2),
  houseNumber: z.string().min(1).max(12),
  street: z.string().min(1).max(46),
  zip: z.string().min(1).max(10),
});

export const zSepaDateOfBirth = z.object({
  day: z.string().regex(/^(0?[1-9]|[12][0-9]|3[01])$/),
  month: z.string().regex(/^(0?[1-9]|1[0-2])$/),
  year: z.string().regex(/^[0-9]{4}$/),
});

export const zSepaUserData = z.object({
  address: zSepaAddress,
  dateOfBirth: zSepaDateOfBirth,
  firstName: z.string().min(1).max(44),
  lastName: z.string().min(1).max(46),
});

export const zSepaRequest = z.object({
  $schema: z.url().readonly().optional(),
  iban: z.string().length(22),
  sepaUserData: zSepaUserData,
});

export const zShipment = z.object({
  charges: z.number(),
  createdAt: z.iso.datetime({ offset: true }),
  externalId: z.string().optional(),
  id: z.string(),
  logisticsProviderInformation: zLogisticsProviderInformation.optional(),
  recipient: zRecipient,
  shipmentReason: z.string().optional(),
  shippedAt: z.iso.datetime({ offset: true }).optional(),
  state: z.string(),
  stateUpdatedAt: z.iso.datetime({ offset: true }).optional(),
  type: z.string(),
});

export const zOrder = z.object({
  createdAt: z.iso.datetime({ offset: true }),
  id: z.string(),
  items: z.array(zOrderItem).nullable(),
  orderType: z.string(),
  originalOrderId: z.string().optional(),
  productId: z.string().optional(),
  shipments: z.array(zShipment).nullable(),
  state: z.string(),
  stateUpdatedAt: z.iso.datetime({ offset: true }),
  transactionId: z.string().optional(),
});

export const zShipmentDto = z.object({
  createdAt: z.iso.datetime({ offset: true }),
  id: z.string(),
  returnLabelUrl: z.string().optional(),
  shippedAt: z.iso.datetime({ offset: true }).optional(),
  state: z.string(),
  trackingId: z.string().optional(),
  trackingUrl: z.string().optional(),
  type: z.string(),
});

export const zPhysicalGoodDetailsDto = z.object({
  articleNumber: z.string(),
  returnableUntil: z.iso.datetime({ offset: true }).optional(),
  serialNumber: z.string().optional(),
  shipments: z.array(zShipmentDto).nullable(),
  shippedAt: z.iso.datetime({ offset: true }).optional(),
  status: z.string().optional(),
});

export const zStartItemReturnInputBody = z.object({
  $schema: z.url().readonly().optional(),
  orderId: z.string(),
  productId: z.string(),
  withinGracePeriod: z.boolean(),
});

export const zSubJsonDate = z.object({
  day: z.int(),
  month: z.int(),
  year: z.int(),
});

export const zSubscription = z.object({
  discounts: z.array(z.string()).optional(),
  options: z.array(zOption).optional(),
  salesBundleId: z.string().optional(),
  trial: z.boolean().optional(),
  vouchers: z.array(z.string()).optional(),
});

export const zSubscriptionAppliedDiscount = z.object({
  amount: z.number(),
  displayName: z.string(),
  effect: z.number(),
  effectType: z.string(),
  lineAmount: z.number(),
});

export const zSubscriptionCancellationInfo = z.object({
  cancellable: z.boolean(),
  nextPossibleCancellationDate: z.iso.datetime({ offset: true }).optional(),
  scheduledCancellation: zScheduledSubscriptionCancellation.optional(),
});

export const zSubscriptionCapabilities = z.object({
  $schema: z.url().readonly().optional(),
  canBookOptions: z.boolean(),
  canCancelSubscription: z.boolean(),
  canChangePackage: z.boolean(),
  canChangePaymentData: z.boolean(),
  canChangePaymentMethods: z.array(z.string()).nullable(),
  canDeletePaymentData: z.boolean(),
  canOrderHardware: z.boolean(),
  canViewInvoices: z.boolean(),
});

export const zSubscriptionItemDetailsDto = z.object({
  end: z.iso.datetime({ offset: true }).optional(),
  start: z.iso.datetime({ offset: true }),
  status: z.string().optional(),
});

export const zOrderItemDto = z.object({
  displayName: z.string().optional(),
  id: z.string(),
  physicalGoodDetails: zPhysicalGoodDetailsDto.optional(),
  quantity: z.int(),
  subscriptionDetails: zSubscriptionItemDetailsDto.optional(),
  trial: z.boolean(),
  type: z.string().optional(),
});

export const zOrderDto = z.object({
  createdAt: z.iso.datetime({ offset: true }),
  id: z.string(),
  items: z.array(zOrderItemDto).nullable(),
});

export const zOrderHistoryResponse = z.object({
  $schema: z.url().readonly().optional(),
  degradations: z.array(z.string()).nullable(),
  orders: z.array(zOrderDto).nullable(),
});

export const zSubscriptionLineItem = z.object({
  discount: zSubscriptionAppliedDiscount.optional(),
  displayName: z.string(),
  finalLinePrice: z.number(),
  finalPrice: z.number(),
  id: z.string(),
  originalLinePrice: z.number(),
  originalPrice: z.number(),
  quantity: z.int(),
  type: z.enum(['MODIFICATION', 'OPTION', 'PHYSICAL_GOOD', 'PRODUCT', 'SHIPPING_FEE']),
});

export const zSubscriptionOneTimeCharge = z.object({
  lineItems: z.array(zSubscriptionLineItem).nullable(),
  subTotal: z.number(),
});

export const zSubscriptionRecurringCharge = z.object({
  duration: zPeriod.optional(),
  lineItems: z.array(zSubscriptionLineItem).nullable(),
  start: z.iso.datetime({ offset: true }),
  subTotal: z.number(),
  type: z.enum(['DISCOUNT', 'PAID_UPFRONT', 'REGULAR', 'SUBSEQUENT', 'TRIAL']),
});

export const zSubscriptionPriceBreakdown = z.object({
  $schema: z.url().readonly().optional(),
  initialTotal: z.number(),
  monthly: z.array(zSubscriptionRecurringCharge).nullable(),
  oneTime: zSubscriptionOneTimeCharge,
});

export const zSubscriptionRequirements = z.object({
  allowedPaymentMethods: z.array(z.string()).nullable(),
  billingAndShippingAddress: z.boolean(),
  paymentData: z.boolean(),
  promptPaymentData: z.boolean(),
});

export const zSwitchProductRequest = z.object({
  $schema: z.url().readonly().optional(),
  product: z.string(),
});

export const zTokenActivateBody = z.object({
  $schema: z.url().readonly().optional(),
  dateOfBirth: zDateOfBirthSegments,
  email: z.email(),
  firstName: z.string().min(2).max(50),
  lastName: z.string().min(2).max(50),
  password: z.string(),
  salutation: z.enum(['mr', 'mrs', 'mx']),
  token: z.string().min(1),
  username: z.string().min(1),
});

export const zUnsubscribeBody = z.object({
  $schema: z.url().readonly().optional(),
  category: z.enum(['infos', 'offers', 'partners', 'surveys']),
  token: z.string().min(1),
});

export const zUpdateEmail = z.object({
  $schema: z.url().readonly().optional(),
  email: z.string(),
  password: z.string().optional(),
});

export const zUpdateEnabledInputBody = z.object({
  $schema: z.url().readonly().optional(),
  enabled: z.boolean(),
});

export const zUpdatePassword = z.object({
  $schema: z.url().readonly().optional(),
  password: z.string(),
});

export const zUpdatePinInputBody = z.object({
  $schema: z.url().readonly().optional(),
  pin: z.string().regex(/^[0-9]{4}$/),
});

export const zUpdateRecentlyWatchedRowRequest = z.object({
  $schema: z.url().readonly().optional(),
  enabled: z.boolean(),
});

export const zUser = z.object({
  $schema: z.url().readonly().optional(),
  address: zAddress.optional(),
  age: z.int().optional(),
  amazonUserId: z.string().optional(),
  appleUserId: z.string().optional(),
  billwerkId: z.int().optional(),
  createSupportLoginPossible: z.boolean().optional(),
  createdAt: z.iso.datetime({ offset: true }).optional(),
  dateOfBirth: zSubJsonDate.optional(),
  deletedAt: z.iso.datetime({ offset: true }).optional(),
  doiStatus: z.enum(['CONFIRMED', 'CONFIRMED_BY_PARTNER', 'PRE_CONFIRMED', 'REGISTERED', 'UNKNOWN']).optional(),
  email: z.string().optional(),
  enabled: z.boolean().optional(),
  firstName: z.string().optional(),
  freenetId: z.string().optional(),
  gender: z.string().optional(),
  googleUserId: z.string().optional(),
  identityProvider: z.string().optional(),
  insecurePassword: z.boolean().optional(),
  isTokenUser: z.boolean().optional(),
  lastName: z.string().optional(),
  missingRequiredFields: z.boolean().optional(),
  originalSalesChannel: z.string().optional(),
  phone: z.string().optional(),
  registrationSource: z.string().optional(),
  restricted: z.boolean().optional(),
  salesChannel: z.string().optional(),
  salutation: z.string().optional(),
  shippingAddress: zAddress.optional(),
  subscriptionOnActivation: zSubscription.optional(),
  supportLogin: z.boolean().optional(),
  tenant: z.string(),
  userhandle: z.string().optional(),
});

export const zUserInfo = z.object({
  $schema: z.url().readonly().optional(),
  email: z.string(),
  emailConfirmationStatus: z.string(),
  familyName: z.string().optional(),
  flags: z.array(z.string()).nullable(),
  givenName: z.string().optional(),
  name: z.string().optional(),
  userHandle: z.string(),
});

export const zUserSubscriptionFlags = z.object({
  currentlyBookedFlexOption: z.boolean(),
  currentlyBookedMobileUsageOption: z.boolean(),
  currentlyInFreeOrPositivePerfect: z.boolean(),
  currentlyInPositivePerfect: z.boolean(),
  ftvVoucherAllowed: z.boolean(),
  hadIapSalesBundle: z.boolean(),
  hadNegativeTrial: z.boolean(),
  hadPaidSubscription: z.boolean(),
  hadPerfect: z.boolean(),
  hadPositivePerfect: z.boolean(),
  instantRestartAllowed: z.boolean(),
  isDirectSubscription: z.boolean(),
  isInFreeSubscription: z.boolean(),
  mobileUsageAllowed: z.boolean(),
});

export const zUserSubscription = z.object({
  $schema: z.url().readonly().optional(),
  activeDiscountSubscriptions: z.array(zDiscountSubscription).nullable(),
  activeIapSubscriptions: z.array(zIapSubscription).nullable(),
  activeModificationSubscriptions: z.array(zModificationSubscription).nullable(),
  activeOptionSubscriptions: z.array(zOptionSubscription).nullable(),
  activeProductSubscription: zProductSubscriptionPhase,
  activeTier: z.enum(['COMFORT', 'FREE', 'NONE', 'PERFECT', 'PERFECT_PLUS', 'START']),
  billedBy: z.string(),
  cancellationInfo: zSubscriptionCancellationInfo,
  discountSubscriptions: z.array(zDiscountSubscription).nullable(),
  dunningLevel: z.int().optional(),
  externalBookingCode: z.string().optional(),
  externalId: z.string().optional(),
  features: zCategorizedFeatures,
  flags: zUserSubscriptionFlags,
  modificationSubscriptions: z.array(zModificationSubscription).nullable(),
  optionSubscriptions: z.array(zOptionSubscription).nullable(),
  paymentMethod: z.string().optional(),
  productSubscriptions: z.array(zProductSubscriptionPhase).nullable(),
  state: z.string(),
  userHandle: z.string(),
});

export const zUserUpdate = z.object({
  $schema: z.url().readonly().optional(),
  address: zAddress.optional(),
  dateOfBirth: z.string().optional(),
  email: z.string().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  password: z.string().optional(),
  phone: z.string().optional(),
  salutation: z.string().optional(),
});

export const zVerifyTokenBody = z.object({
  $schema: z.url().readonly().optional(),
  activationProcessStatus: z.string(),
  bookableId: z.string().optional(),
  customerId: z.string(),
  dateOfBirth: z.string().optional(),
  email: z.string().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  productId: z.string(),
  salesChannel: z.string().optional(),
  salutation: z.string().optional(),
  source: z.string().optional(),
});

export const zVerifyTokenInputBody = z.object({
  $schema: z.url().readonly().optional(),
  token: z.string().min(1),
  username: z.string().min(1),
});

export const zVisibility = z.object({
  bookingFunnel: z.boolean(),
  selfServiceOverview: z.boolean(),
  testerOnly: z.boolean(),
});

export const zWithdrawalHint = z.object({
  consentRequired: z.boolean(),
  id: z.string(),
  postBookingText: z.string().optional(),
  preBookingText: z.string().optional(),
});

export const zBookableV2 = z.object({
  $schema: z.url().readonly().optional(),
  additionalBookables: z.array(z.lazy((): any => zBookableV2)).nullable(),
  backgroundImages: z.array(zImage).nullable(),
  defaultLogos: z.array(zImage).nullable(),
  displayTexts: zBookableDisplayTexts,
  enabled: z.boolean(),
  featureTeaserImages: z.array(zImage).nullable(),
  iapProduct: zIapProduct.optional(),
  id: z.string(),
  includedItems: z.array(zBookableIncludedItem).nullable(),
  minimumTerm: zPeriod.optional(),
  subscriptionRequirements: zSubscriptionRequirements,
  trialPeriod: zPeriod.optional(),
  type: z.string(),
  visibility: zVisibility,
  withdrawalHint: zWithdrawalHint,
});

export const zWithdrawalRequestResource = z.object({
  $schema: z.url().readonly().optional(),
  customerId: z.string().optional(),
  email: z.string(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  orderDate: z.string().optional(),
  product: z.string().optional(),
  receiptEmail: z.string().optional(),
  userHandle: z.string().optional(),
});

export const zAmazonLoginBodyWritable = z.object({
  accessToken: z.string().max(4096),
});

export const zAmazonLoginResponseBodyWritable = z.object({
  success: z.boolean(),
});

export const zAppleLoginBodyWritable = z.object({
  authorizationCode: z.string().max(4096),
  identityToken: z.string().max(8192),
});

export const zAppleLoginResponseBodyWritable = z.object({
  success: z.boolean(),
});

export const zAppleRegisterInputBodyWritable = z.object({
  authorizationCode: z.string().max(4096),
  familyName: z.string().max(256).optional(),
  givenName: z.string().max(256).optional(),
  identityToken: z.string().max(8192),
});

export const zApproveDeviceAuthorizationBodyWritable = z.object({
  approval: z.enum(['ALLOW', 'DENY']),
});

export const zAuthSuccessResponseWritable = z.object({
  success: z.boolean(),
});

export const zBookableV2Writable = z.object({
  additionalBookables: z.array(z.lazy((): any => zBookableV2Writable)).nullable(),
  backgroundImages: z.array(zImage).nullable(),
  defaultLogos: z.array(zImage).nullable(),
  displayTexts: zBookableDisplayTexts,
  enabled: z.boolean(),
  featureTeaserImages: z.array(zImage).nullable(),
  iapProduct: zIapProduct.optional(),
  id: z.string(),
  includedItems: z.array(zBookableIncludedItem).nullable(),
  minimumTerm: zPeriod.optional(),
  subscriptionRequirements: zSubscriptionRequirements,
  trialPeriod: zPeriod.optional(),
  type: z.string(),
  visibility: zVisibility,
  withdrawalHint: zWithdrawalHint,
});

export const zCancellationRequestWritable = z.object({
  customerId: z.string(),
  dateOfBirth: z.string(),
  emailAddress: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  reason: z.string(),
  terminationType: z.string(),
});

export const zCheckEmailAvailabilityBodyWritable = z.object({
  available: z.boolean(),
  reason: z.enum(['invalid_domain', 'taken']).optional(),
  takenBy: z.string(),
});

export const zCommunicationPreferencesDtoWritable = z.object({
  settings: zCommunicationPreferencesSettingsDto,
});

export const zCompleteRegistrationInputBodyWritable = z.object({
  dateOfBirth: z.string(),
  firstName: z.string().min(1).max(100),
  lastName: z.string().min(1).max(100),
  salutation: z.enum(['mr', 'mrs', 'mx']).optional(),
});

export const zConfiguratorSessionWritable = z.object({
  cart: zCart,
  catalog: zCatalog,
  id: z.string(),
  transactionId: z.string(),
});

export const zCreateSessionInputBodyWritable = z.object({
  entryContext: z.enum(['OPEN_NEW']),
});

export const zCreateVerificationInputBodyWritable = z.object({
  cardType: z.enum(['NewIdCard', 'NewIdCard2108', 'OldIdCard', 'Passport']),
  idParts: z.array(z.string()).min(1).max(5).nullable(),
  pin: z.string().regex(/^[0-9]{4}$/),
});

export const zDeviceAuthorizationBodyWritable = z.object({
  deviceName: z.string().optional(),
  status: z.enum(['NOT_EXISTING', 'EXPIRED', 'PENDING', 'DENIED', 'VERIFIED', 'TENANT_MISMATCH']),
});

export const zEmailValidationWritable = z.object({
  token: z.string(),
});

export const zErrorModelWritable = z.object({
  detail: z.string().optional(),
  errors: z.array(zErrorDetail).nullish(),
  instance: z.url().optional(),
  status: z.int().optional(),
  title: z.string().optional(),
  type: z.url().optional().default('about:blank'),
});

export const zGetActiveDevicesResponseBodyWritable = z.object({
  currentDeviceId: z.string(),
  data: z.array(zActiveDevice).nullable(),
});

export const zGetPermissionsOutputBodyWritable = z.object({
  data: z.array(zPermission).nullable(),
});

export const zGoogleLoginBodyWritable = z.object({
  credential: z.string().max(4096),
});

export const zGoogleLoginResponseBodyWritable = z.object({
  success: z.boolean(),
});

export const zHomeZoneStatusResponseWritable = z.object({
  accessPointCount: z.int().optional(),
  accessPointLimit: z.int().optional(),
  approximateLocation: zApproximateLocation.optional(),
  createdAt: z.string().optional(),
  location: zHomeZoneLocation.optional(),
  nextChangeAllowedAt: z.string().optional(),
  updatedAt: z.string().optional(),
});

export const zLinkAppleInputBodyWritable = z.object({
  identityToken: z.string().max(8192),
});

export const zLocationEligibilityBodyWritable = z.object({
  eligible: z.boolean(),
});

export const zLogoutBodyWritable = z.object({
  logoutUrl: z.string(),
});

export const zOrderHistoryResponseWritable = z.object({
  degradations: z.array(z.string()).nullable(),
  orders: z.array(zOrderDto).nullable(),
});

export const zParentalControlsStatusBodyWritable = z.object({
  enabled: z.boolean(),
  verified: z.boolean(),
});

export const zPasswordBreachCheckResponseBodyWritable = z.object({
  entries: z.array(zEntry),
});

export const zPasswordResetConfirmationWritable = z.object({
  password: z.string(),
  token: z.string(),
});

export const zPasswordResetRequestWritable = z.object({
  email: z.string(),
  tenant: z.string().optional(),
});

export const zPasswordResetTokenValidationWritable = z.object({
  token: z.string(),
});

export const zPaymentMethodWritable = z.object({
  cardType: z.string().optional(),
  email: z.string().optional(),
  expiryMonth: z.int().optional(),
  expiryYear: z.int().optional(),
  holder: z.string().optional(),
  iban: z.string().optional(),
  last4: z.string().optional(),
  mandateReference: z.string().optional(),
  name: z.string().optional(),
  type: z.enum(['creditcard', 'sepa', 'paypal', 'none']),
});

export const zPostFeedbackInputBodyWritable = z.object({
  fields: z.record(z.string(), z.unknown()),
  formId: z.string().min(1),
});

export const zPriceSummaryWritable = z.object({
  monthly: z.array(zMonthlyPriceSummary).nullable(),
  oneTime: zOneTimePriceSummary,
});

export const zReAuthenticateBodyWritable = z.object({
  expiresAt: z.string(),
  stepUpToken: z.string(),
});

export const zReAuthenticateInputBodyWritable = z.object({
  password: z.string().min(1),
});

export const zRecentlyWatchedRowDtoWritable = z.object({
  editable: z.boolean(),
  editableLockedReason: z.string().optional(),
  enabled: z.boolean(),
});

export const zRecordingSummaryWritable = z.object({
  availableRecordingHours: z.int(),
  finishedRecordingsSeconds: z.int(),
  numberOfFinishedRecordings: z.int(),
  numberOfLostRecordings: z.int(),
});

export const zRedeemBodyWritable = z.object({
  city: z.string().min(1).max(255),
  consentAccepted: z.literal(true),
  country: z.enum(['DE']),
  email: z.email().min(1).max(255),
  firstName: z.string().min(1).max(255),
  houseNumber: z.string().min(1).max(16),
  lastName: z.string().min(1).max(255),
  salutation: z.enum(['mr', 'mrs', 'mx']),
  street: z.string().min(1).max(255),
  zip: z.string().regex(/^[0-9]{5}$/),
});

export const zRedeemOutputBodyWritable = z.object({
  basketUrl: z.string(),
});

export const zRefreshSessionBodyWritable = z.object({
  flags: z.array(z.string()).nullable(),
  userHandle: z.string(),
});

export const zRegisterInputBodyWritable = z.object({
  context: z.string().optional(),
  dateOfBirth: z.string(),
  emailAddress: z.email(),
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  password: z.string().min(8),
  salutation: z.string().optional(),
  source: z.string().optional(),
});

export const zRetrieveSelfServiceTokenResultWritable = z.object({
  token: z.string(),
});

export const zSepaRequestWritable = z.object({
  iban: z.string().length(22),
  sepaUserData: zSepaUserData,
});

export const zStartItemReturnInputBodyWritable = z.object({
  orderId: z.string(),
  productId: z.string(),
  withinGracePeriod: z.boolean(),
});

export const zSubscriptionCapabilitiesWritable = z.object({
  canBookOptions: z.boolean(),
  canCancelSubscription: z.boolean(),
  canChangePackage: z.boolean(),
  canChangePaymentData: z.boolean(),
  canChangePaymentMethods: z.array(z.string()).nullable(),
  canDeletePaymentData: z.boolean(),
  canOrderHardware: z.boolean(),
  canViewInvoices: z.boolean(),
});

export const zSubscriptionPriceBreakdownWritable = z.object({
  initialTotal: z.number(),
  monthly: z.array(zSubscriptionRecurringCharge).nullable(),
  oneTime: zSubscriptionOneTimeCharge,
});

export const zSwitchProductRequestWritable = z.object({
  product: z.string(),
});

export const zTokenActivateBodyWritable = z.object({
  dateOfBirth: zDateOfBirthSegments,
  email: z.email(),
  firstName: z.string().min(2).max(50),
  lastName: z.string().min(2).max(50),
  password: z.string(),
  salutation: z.enum(['mr', 'mrs', 'mx']),
  token: z.string().min(1),
  username: z.string().min(1),
});

export const zUnsubscribeBodyWritable = z.object({
  category: z.enum(['infos', 'offers', 'partners', 'surveys']),
  token: z.string().min(1),
});

export const zUpdateEmailWritable = z.object({
  email: z.string(),
  password: z.string().optional(),
});

export const zUpdateEnabledInputBodyWritable = z.object({
  enabled: z.boolean(),
});

export const zUpdatePasswordWritable = z.object({
  password: z.string(),
});

export const zUpdatePinInputBodyWritable = z.object({
  pin: z.string().regex(/^[0-9]{4}$/),
});

export const zUpdateRecentlyWatchedRowRequestWritable = z.object({
  enabled: z.boolean(),
});

export const zUserWritable = z.object({
  address: zAddress.optional(),
  age: z.int().optional(),
  amazonUserId: z.string().optional(),
  appleUserId: z.string().optional(),
  billwerkId: z.int().optional(),
  createSupportLoginPossible: z.boolean().optional(),
  createdAt: z.iso.datetime({ offset: true }).optional(),
  dateOfBirth: zSubJsonDate.optional(),
  deletedAt: z.iso.datetime({ offset: true }).optional(),
  doiStatus: z.enum(['CONFIRMED', 'CONFIRMED_BY_PARTNER', 'PRE_CONFIRMED', 'REGISTERED', 'UNKNOWN']).optional(),
  email: z.string().optional(),
  enabled: z.boolean().optional(),
  firstName: z.string().optional(),
  freenetId: z.string().optional(),
  gender: z.string().optional(),
  googleUserId: z.string().optional(),
  identityProvider: z.string().optional(),
  insecurePassword: z.boolean().optional(),
  isTokenUser: z.boolean().optional(),
  lastName: z.string().optional(),
  missingRequiredFields: z.boolean().optional(),
  originalSalesChannel: z.string().optional(),
  phone: z.string().optional(),
  registrationSource: z.string().optional(),
  restricted: z.boolean().optional(),
  salesChannel: z.string().optional(),
  salutation: z.string().optional(),
  shippingAddress: zAddress.optional(),
  subscriptionOnActivation: zSubscription.optional(),
  supportLogin: z.boolean().optional(),
  tenant: z.string(),
  userhandle: z.string().optional(),
});

export const zUserInfoWritable = z.object({
  email: z.string(),
  emailConfirmationStatus: z.string(),
  familyName: z.string().optional(),
  flags: z.array(z.string()).nullable(),
  givenName: z.string().optional(),
  name: z.string().optional(),
  userHandle: z.string(),
});

export const zUserSubscriptionWritable = z.object({
  activeDiscountSubscriptions: z.array(zDiscountSubscription).nullable(),
  activeIapSubscriptions: z.array(zIapSubscription).nullable(),
  activeModificationSubscriptions: z.array(zModificationSubscription).nullable(),
  activeOptionSubscriptions: z.array(zOptionSubscription).nullable(),
  activeProductSubscription: zProductSubscriptionPhase,
  activeTier: z.enum(['COMFORT', 'FREE', 'NONE', 'PERFECT', 'PERFECT_PLUS', 'START']),
  billedBy: z.string(),
  cancellationInfo: zSubscriptionCancellationInfo,
  discountSubscriptions: z.array(zDiscountSubscription).nullable(),
  dunningLevel: z.int().optional(),
  externalBookingCode: z.string().optional(),
  externalId: z.string().optional(),
  features: zCategorizedFeatures,
  flags: zUserSubscriptionFlags,
  modificationSubscriptions: z.array(zModificationSubscription).nullable(),
  optionSubscriptions: z.array(zOptionSubscription).nullable(),
  paymentMethod: z.string().optional(),
  productSubscriptions: z.array(zProductSubscriptionPhase).nullable(),
  state: z.string(),
  userHandle: z.string(),
});

export const zUserUpdateWritable = z.object({
  address: zAddress.optional(),
  dateOfBirth: z.string().optional(),
  email: z.string().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  password: z.string().optional(),
  phone: z.string().optional(),
  salutation: z.string().optional(),
});

export const zVerifyTokenBodyWritable = z.object({
  activationProcessStatus: z.string(),
  bookableId: z.string().optional(),
  customerId: z.string(),
  dateOfBirth: z.string().optional(),
  email: z.string().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  productId: z.string(),
  salesChannel: z.string().optional(),
  salutation: z.string().optional(),
  source: z.string().optional(),
});

export const zVerifyTokenInputBodyWritable = z.object({
  token: z.string().min(1),
  username: z.string().min(1),
});

export const zWithdrawalRequestResourceWritable = z.object({
  customerId: z.string().optional(),
  email: z.string(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  orderDate: z.string().optional(),
  product: z.string().optional(),
  receiptEmail: z.string().optional(),
  userHandle: z.string().optional(),
});

export const zAmazonLoginBody2 = zAmazonLoginBodyWritable;

/**
 * OK
 */
export const zAmazonLoginResponse = zAmazonLoginResponseBody;

export const zAmazonRegisterBody = zAmazonLoginBodyWritable;

export const zAmazonRegisterHeaders = z.object({
  'User-Agent': z.string().optional(),
});

/**
 * OK
 */
export const zAmazonRegisterResponse = zAuthSuccessResponse;

export const zAppleLoginBody2 = zAppleLoginBodyWritable;

/**
 * OK
 */
export const zAppleLoginResponse = zAppleLoginResponseBody;

export const zAppleRegisterBody = zAppleRegisterInputBodyWritable;

/**
 * OK
 */
export const zAppleRegisterResponse = zAuthSuccessResponse;

export const zGetDeviceAuthorizationPath = z.object({
  'user-code': z.string().regex(/^[A-Za-z]{4}-[A-Za-z]{4}$/),
});

/**
 * OK
 */
export const zGetDeviceAuthorizationResponse = zDeviceAuthorizationBody;

export const zApproveDeviceAuthorizationBody2 = zApproveDeviceAuthorizationBodyWritable;

export const zApproveDeviceAuthorizationHeaders = z.object({
  'User-Agent': z.string().optional(),
});

export const zApproveDeviceAuthorizationPath = z.object({
  'user-code': z.string().regex(/^[A-Za-z]{4}-[A-Za-z]{4}$/),
});

/**
 * No Content
 */
export const zApproveDeviceAuthorizationResponse = z.void();

export const zGoogleLoginBody2 = zGoogleLoginBodyWritable;

/**
 * OK
 */
export const zGoogleLoginResponse = zGoogleLoginResponseBody;

export const zGoogleRegisterBody = zGoogleLoginBodyWritable;

/**
 * OK
 */
export const zGoogleRegisterResponse = zAuthSuccessResponse;

export const zLogoutQuery = z.object({
  returnTo: z.string().optional(),
});

/**
 * OK
 */
export const zLogoutResponse = zLogoutBody;

export const zPasswordBreachCheckPath = z.object({
  prefix: z.string().regex(/^[0-9A-Fa-f]{5}$/),
});

/**
 * OK
 */
export const zPasswordBreachCheckResponse = zPasswordBreachCheckResponseBody;

export const zPasswordResetConfirmBody = zPasswordResetConfirmationWritable;

/**
 * No Content
 */
export const zPasswordResetConfirmResponse = z.void();

export const zPasswordResetRequestBody = zPasswordResetRequestWritable;

export const zPasswordResetRequestHeaders = z.object({
  'X-Recaptcha-Token': z.string().optional(),
});

/**
 * Accepted
 */
export const zPasswordResetRequestResponse2 = zPasswordResetRequestResponse;

export const zPasswordResetVerifyBody = zPasswordResetTokenValidationWritable;

/**
 * No Content
 */
export const zPasswordResetVerifyResponse = z.void();

export const zReAuthenticateBody2 = zReAuthenticateInputBodyWritable;

export const zReAuthenticateHeaders = z.object({
  'X-Recaptcha-Token': z.string().optional(),
});

/**
 * OK
 */
export const zReAuthenticateResponse = zReAuthenticateBody;

/**
 * OK
 */
export const zRefreshSessionResponse = zRefreshSessionBody;

/**
 * No Content
 */
export const zDeleteParentalControlsVerificationResponse = z.void();

/**
 * OK
 */
export const zGetParentalControlsVerificationResponse = zParentalControlsStatusBody;

export const zCreateParentalControlsVerificationBody = zCreateVerificationInputBodyWritable;

/**
 * OK
 */
export const zCreateParentalControlsVerificationResponse = zParentalControlsStatusBody;

export const zUpdateParentalControlsEnabledBody = zUpdateEnabledInputBodyWritable;

/**
 * OK
 */
export const zUpdateParentalControlsEnabledResponse = zParentalControlsStatusBody;

export const zUpdateParentalControlsPinBody = zUpdatePinInputBodyWritable;

/**
 * OK
 */
export const zUpdateParentalControlsPinResponse = zParentalControlsStatusBody;

/**
 * OK
 */
export const zGetSessionResponse = zUserInfo;

export const zActivationActivateBody = zTokenActivateBodyWritable;

export const zActivationActivateHeaders = z.object({
  'X-Recaptcha-Token': z.string().optional(),
  'User-Agent': z.string().optional(),
});

/**
 * No Content
 */
export const zActivationActivateResponse = z.void();

export const zActivationVerifyTokenBody = zVerifyTokenInputBodyWritable;

/**
 * OK
 */
export const zActivationVerifyTokenResponse = zVerifyTokenBody;

/**
 * OK
 */
export const zGetInvoicesResponse = z.array(zInvoiceView).nullable();

export const zDownloadInvoicePdfPath = z.object({
  id: z.string(),
});

export const zDownloadInvoicePdfQuery = z.object({
  token: z.string().optional(),
});

/**
 * No Content
 */
export const zDeletePaymentBearerResponse = z.void();

/**
 * OK
 */
export const zGetPaymentBearerResponse = zPaymentMethod;

/**
 * OK
 */
export const zGetSelfServiceTokenResponse = zRetrieveSelfServiceTokenResult;

export const zSetSepaPaymentBody = zSepaRequestWritable;

export const zSetSepaPaymentHeaders = z.object({
  'X-Recaptcha-Token': z.string().optional(),
});

/**
 * No Content
 */
export const zSetSepaPaymentResponse = z.void();

export const zGetBookablePath = z.object({
  id: z.string(),
});

/**
 * OK
 */
export const zGetBookableResponse = zBookableV2;

export const zCreateBookingSessionBody = zCreateSessionInputBodyWritable;

/**
 * OK
 */
export const zCreateBookingSessionResponse = zConfiguratorSession;

export const zGetBookingSessionPath = z.object({
  id: z.string(),
});

/**
 * OK
 */
export const zGetBookingSessionResponse = zConfiguratorSession;

export const zGetBookingPriceSummaryPath = z.object({
  id: z.string(),
});

/**
 * OK
 */
export const zGetBookingPriceSummaryResponse = zPriceSummary;

export const zSwitchBookingProductBody = zSwitchProductRequestWritable;

export const zSwitchBookingProductPath = z.object({
  id: z.string(),
});

/**
 * No Content
 */
export const zSwitchBookingProductResponse = z.void();

export const zRedeemFunkeOfferBody = zRedeemBodyWritable;

export const zRedeemFunkeOfferHeaders = z.object({
  'X-Recaptcha-Token': z.string().optional(),
  'User-Agent': z.string().optional(),
});

/**
 * OK
 */
export const zRedeemFunkeOfferResponse = zRedeemOutputBody;

export const zRequestCancellationBody = zCancellationRequestWritable;

export const zRequestCancellationHeaders = z.object({
  'X-Recaptcha-Token': z.string().optional(),
});

/**
 * No Content
 */
export const zRequestCancellationResponse = z.void();

/**
 * OK
 */
export const zGetCommunicationPreferencesResponse = zCommunicationPreferencesDto;

export const zUnsubscribeCommunicationPreferencesBody = zUnsubscribeBodyWritable;

/**
 * No Content
 */
export const zUnsubscribeCommunicationPreferencesResponse = z.void();

export const zUpdateCommunicationPreferencesBody = zCommunicationPreferencesDtoWritable;

/**
 * OK
 */
export const zUpdateCommunicationPreferencesResponse = zCommunicationPreferencesDto;

export const zGetDevicesQuery = z.object({
  limit: z.int().optional().default(5),
});

/**
 * OK
 */
export const zGetDevicesResponse = zGetActiveDevicesResponseBody;

export const zRemoveAllDevicesQuery = z.object({
  currentDevice: z.string().optional(),
});

/**
 * No Content
 */
export const zRemoveAllDevicesResponse = z.void();

export const zRemoveDevicePath = z.object({
  'device-id': z.string(),
});

/**
 * No Content
 */
export const zRemoveDeviceResponse = z.void();

export const zEmailCheckQuery = z.object({
  email: z.email(),
});

/**
 * OK
 */
export const zEmailCheckResponse = zCheckEmailAvailabilityBody;

export const zAddFeedbackBody = zPostFeedbackInputBodyWritable;

/**
 * No Content
 */
export const zAddFeedbackResponse = z.void();

/**
 * OK
 */
export const zGetHardwareProductsResponse = z.array(zHardwareProduct).nullable();

/**
 * OK
 */
export const zGetHomeZoneStatusResponse = zHomeZoneStatusResponse;

export const zGetReturnLabelPath = z.object({
  provider: z.enum(['amz', 'md']),
  returnLabelId: z.string(),
});

export const zGetReturnLabelQuery = z.object({
  token: z.string().optional(),
});

/**
 * OK
 */
export const zGetOrderHistoryResponse = zOrderHistoryResponse;

export const zStartItemReturnBody = zStartItemReturnInputBodyWritable;

/**
 * No Content
 */
export const zStartItemReturnResponse = z.void();

/**
 * OK
 */
export const zListOrdersResponse = z.array(zOrder).nullable();

/**
 * OK
 */
export const zGetPermissionsResponse = zGetPermissionsOutputBody;

/**
 * OK
 */
export const zGetPriceBreakdownResponse = zSubscriptionPriceBreakdown;

/**
 * OK
 */
export const zGetSummaryResponse = zRecordingSummary;

export const zRegistrationRegisterBody = zRegisterInputBodyWritable;

export const zRegistrationRegisterHeaders = z.object({
  'X-Recaptcha-Token': z.string().optional(),
  'User-Agent': z.string().optional(),
});

/**
 * No Content
 */
export const zRegistrationRegisterResponse = z.void();

export const zCompleteRegistrationBody = zCompleteRegistrationInputBodyWritable;

/**
 * OK
 */
export const zCompleteRegistrationResponse = zUser;

/**
 * OK
 */
export const zRegistrationLocationEligibilityResponse = zLocationEligibilityBody;

/**
 * OK
 */
export const zGetRecentlyWatchedResponse = zRecentlyWatchedRowDto;

export const zUpdateRecentlyWatchedBody = zUpdateRecentlyWatchedRowRequestWritable;

/**
 * OK
 */
export const zUpdateRecentlyWatchedResponse = zRecentlyWatchedRowDto;

/**
 * OK
 */
export const zGetSubscriptionResponse = zUserSubscription;

/**
 * OK
 */
export const zGetSubscriptionCapabilitiesResponse = zSubscriptionCapabilities;

/**
 * OK
 */
export const zGetUserResponse = zUser;

export const zLinkAppleIdentityBody = zLinkAppleInputBodyWritable;

/**
 * OK
 */
export const zLinkAppleIdentityResponse = zUser;

export const zChangeEmailBody = zUpdateEmailWritable;

/**
 * OK
 */
export const zChangeEmailResponse = zUser;

export const zChangePasswordBody = zUpdatePasswordWritable;

/**
 * No Content
 */
export const zChangePasswordResponse = z.void();

export const zUpdatePersonalDataBody = zUserUpdateWritable;

/**
 * OK
 */
export const zUpdatePersonalDataResponse = zUser;

export const zVerifyEmailBody = zEmailValidationWritable;

/**
 * No Content
 */
export const zVerifyEmailResponse = z.void();

export const zRequestWithdrawalBody = zWithdrawalRequestResourceWritable;

export const zRequestWithdrawalHeaders = z.object({
  'X-Recaptcha-Token': z.string().optional(),
});

/**
 * No Content
 */
export const zRequestWithdrawalResponse = z.void();
